import { getMonth, getYear } from "../../utils/functions/date-helper";
import { Tag } from "primereact/tag";

export const ExpirateBodyTemplate = (rowData: any) => {
  const expirated = (rowData.expiratedDate as string).toString() || "";

  if (!expirated) return <span className="text-color-secondary">-</span>;

  if (expirated === "0") {
    let expirateDate = new Date(rowData.createDate);
    const dateFormatted = new Date(
      getYear(),
      getMonth(),
      expirateDate.getDate()
    ).toLocaleDateString();

    return (
      <div className="flex align-items-center text-900">
        <i className="pi pi-calendar mr-2 text-color-secondary"></i>
        {dateFormatted}
      </div>
    );
  }

  if (expirated.length < 3) {
    return (
      <Tag
        value={`${expirated} de cada mes`}
        severity="info"
        rounded
        className="px-2"
      />
    );
  }

  const date = new Date(expirated).toLocaleDateString() || "";
  return (
    <div className="flex align-items-center text-900">
      <i className="pi pi-calendar mr-2 text-color-secondary"></i>
      {date}
    </div>
  );
};
